import { render, staticRenderFns } from "./BackgroundOverlay.vue?vue&type=template&id=0cb2517e&scoped=true&"
import script from "./BackgroundOverlay.vue?vue&type=script&lang=ts&"
export * from "./BackgroundOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./BackgroundOverlay.vue?vue&type=style&index=0&id=0cb2517e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb2517e",
  null
  
)

export default component.exports